import { render, staticRenderFns } from "./AssessmentPeriodDetail.vue?vue&type=template&id=679834d8"
import script from "./assessment-period-detail.ts?vue&type=script&lang=ts&external"
export * from "./assessment-period-detail.ts?vue&type=script&lang=ts&external"
import style0 from "./assessment-period-detail.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports